import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 200,
    display: 'block',
    color: '#ffffff',
  },
  path: {
    fill: 'currentColor',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800.000000 800.000000"
      preserveAspectRatio="xMidYMid meet"
      className={classes.svg}
    >
      <g
        transform="translate(0.000000,800.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none"
      >
        <path
          d="M4180 4455 l0 -145 -65 0 -65 0 0 -90 0 -90 65 0 65 0 0 -277 c0
-172 4 -293 11 -318 17 -62 73 -110 144 -125 57 -12 192 -8 230 6 12 5 15 25
15 98 l0 93 -55 -10 c-65 -12 -100 0 -115 39 -6 14 -10 131 -10 260 l0 234 90
0 90 0 0 90 0 90 -90 0 -90 0 0 145 0 145 -110 0 -110 0 0 -145z"
        />
        <path
          d="M1230 4579 c0 -7 -95 -264 -211 -573 -117 -308 -214 -567 -217 -573
-3 -10 25 -13 121 -13 l125 0 39 118 40 117 225 3 226 2 28 -72 c15 -40 35
-93 44 -118 l18 -45 116 -3 c64 -1 116 1 116 6 0 9 -387 1063 -415 1127 l-14
35 -120 0 c-84 0 -121 -4 -121 -11z m209 -488 l79 -241 -165 0 c-132 0 -164 3
-160 13 3 7 37 114 77 238 75 233 79 243 87 236 2 -3 40 -114 82 -246z"
        />
        <path
          d="M1590 4588 c0 -2 15 -43 34 -93 l33 -90 243 -3 244 -2 -31 -33 c-16
-17 -79 -96 -138 -175 l-109 -143 19 -56 c24 -69 39 -87 65 -73 10 6 43 10 72
10 96 0 162 -66 162 -165 0 -64 -28 -112 -85 -144 -35 -20 -51 -23 -100 -18
-33 3 -59 4 -59 2 0 -2 16 -49 37 -105 l36 -102 60 5 c118 11 243 99 295 210
83 176 20 387 -145 484 l-43 25 32 43 c18 24 61 80 96 126 l63 82 -3 106 -3
106 -387 3 c-214 1 -388 1 -388 0z"
        />
        <path
          d="M2488 4584 c-5 -4 -8 -56 -8 -115 l0 -107 138 -4 c130 -3 140 -5 190
-32 94 -53 150 -132 172 -244 34 -171 -40 -341 -177 -409 -51 -25 -70 -28
-185 -31 -71 -3 -128 -9 -128 -14 0 -24 -58 -127 -93 -165 l-40 -43 196 0
c178 0 203 2 270 23 287 92 448 406 367 721 -27 108 -63 169 -150 257 -119
121 -211 158 -415 166 -71 3 -133 2 -137 -3z"
        />
        <path
          d="M3513 4315 c-29 -8 -70 -23 -91 -34 -42 -21 -145 -128 -137 -141 3
-4 38 -29 80 -54 l74 -47 37 41 c51 57 84 71 160 72 94 0 134 -33 134 -112 0
-24 -5 -31 -27 -36 -333 -79 -415 -119 -469 -230 -22 -46 -27 -69 -27 -128 1
-78 11 -114 49 -164 78 -102 277 -108 427 -12 51 32 54 31 59 -25 l3 -30 110
0 c93 0 109 2 106 15 -2 8 -6 155 -8 325 -4 361 -11 408 -74 478 -57 66 -120
90 -249 94 -71 2 -122 -2 -157 -12z m226 -671 c-36 -39 -100 -64 -160 -64 -69
0 -101 27 -103 87 -2 92 40 129 194 168 l85 22 3 -95 c2 -86 1 -97 -19 -118z"
        />
        <path
          d="M4920 4315 c-76 -22 -130 -56 -184 -116 -54 -60 -56 -54 47 -118 l69
-42 35 41 c42 49 75 67 128 70 84 6 106 1 136 -30 25 -25 30 -36 27 -71 l-3
-42 -110 -24 c-228 -51 -353 -125 -389 -230 -26 -76 -21 -171 12 -234 39 -76
97 -110 195 -117 89 -5 157 12 241 63 32 19 60 35 62 35 2 0 4 -15 4 -32 0
-56 6 -59 121 -56 l104 3 -3 25 c-1 14 -6 174 -10 355 -7 305 -9 333 -28 375
-29 63 -65 97 -132 127 -48 22 -74 27 -162 30 -72 2 -122 -2 -160 -12z m228
-678 c-44 -35 -102 -57 -156 -57 -72 0 -102 28 -102 98 0 85 38 116 187 156
l88 23 3 -101 c3 -94 1 -101 -20 -119z"
        />
        <path
          d="M5634 3953 l-101 -176 102 -176 101 -176 208 -3 c128 -1 206 1 204 7
-8 23 -403 701 -408 701 -3 -1 -50 -80 -106 -177z"
        />
        <path
          d="M6247 4108 c-46 -72 -187 -324 -187 -333 0 -5 45 -86 99 -180 l98
-170 206 -3 c114 -1 207 0 207 2 0 5 -399 698 -405 704 -2 2 -10 -7 -18 -20z"
        />
        <path
          d="M6673 3948 l-100 -173 102 -175 101 -175 207 -3 c173 -2 207 0 200
11 -4 8 -96 165 -203 350 -107 186 -197 337 -201 337 -4 0 -52 -78 -106 -172z"
        />
      </g>
    </svg>
  );
};
